import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { isBetaEnabled } from '~/common/app/beta';
import { FullScreenError } from '~/components/FullScreen';

export function betaOnly() {
  if (!isBetaEnabled()) throw new BetaDisabledError();
}

export function ErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();

  if (!(error instanceof BetaDisabledError)) throw error;

  return <FullScreenError message={t('ui.io.invite.error.generic_error')} />;
}

export class BetaDisabledError extends Error {}
